import { useAppSelector } from "@/store/hooks"
import { bankOrder, mapDesigns } from "@mono/mapDesigns"
import { groupPropertiesByGroupId } from "@/utils/gameHelpers"
import PropertiesSet from "./PropertiesSet"
import React, { useMemo } from "react"
import { TradeScreenPropertyCardProps } from "../Trade/TradeScreenPropertyCard"
import PropertySmallCard from "./PropertySmallCard"
import classNames from "classnames"
import { JailFreeCardSmall } from "@/Components/JailFreeCardSmall"
import { ActionSmallCard } from "@/Components/ActionSmallCard"
import { images } from "@/utils/data"

interface PlayerTabPropertiesProps {
  properties: ICell[]
  playerOrder: PlayerOrder
  PropertyCardComponent?: React.FC<TradeScreenPropertyCardProps>
  forTradeScreen?: boolean
}

const PlayerTabProperties2: React.FC<PlayerTabPropertiesProps> = ({
  properties,
  playerOrder,
  PropertyCardComponent = PropertySmallCard,
  forTradeScreen = false,
}) => {
  const mapId = useAppSelector((state) => state.global.myGame?.settings.mapId)
  const map = mapDesigns.find((map) => map.id === mapId)
  const situation = useAppSelector((state) => state.global.myGame?.situation)
  const player = situation?.players.find((p) => p.order === playerOrder)
  const propertyMoveAnimations = useAppSelector(
    (state) => state.global.animationData.propertyMoveAnimations
  )

  const dummyPropertyOrders = useMemo(() => {
    const myAnimations = propertyMoveAnimations?.filter(
      (animation) => animation.to === playerOrder
    )
    return [...new Set(myAnimations?.map((anim) => anim.propertyOrder))]
  }, [propertyMoveAnimations, playerOrder, properties])

  const dummyProperties: ICell[] | undefined = dummyPropertyOrders?.map(
    (order) => map!.cells.find((cell) => cell.order === order) as ICell
  )
  const totalProperties = dummyProperties
    ? [
        ...properties,
        ...dummyProperties.map(
          (property) =>
            ({ ...property, metadata: { dummySmallCard: true } } as ICell)
        ),
      ]
    : [...properties]

  const propertyGroups = groupPropertiesByGroupId(totalProperties)

  // if (!player) return null

  return (
    <div
      className={classNames(
        "flex gap-4 gap-y-0 overflow-auto w-full  p-3 h-full border-t border-[rgba(255,255,255,0.3)] ",
        {
          "flex-wrap bg-white bg-opacity-20": playerOrder === bankOrder,
          "grid grid-cols-[min-content_auto] gap-x-10": forTradeScreen,
          // "bg-transparent": !forTradeScreen,
          "bg-trade-propertiesBackground": forTradeScreen,
          "border border-[#6E5E5E]": forTradeScreen,
        }
      )}
      data-testid={`game.player-properties-${playerOrder}`}
    >
      {propertyGroups.map((groupObject) => {
        const myGroup = map?.groups.find(
          (g) => g.id === groupObject.groupId
        ) as IPropertyGroup
        return (
          <PropertiesSet
            forTradeScreen={forTradeScreen}
            PropertCardComponent={PropertyCardComponent}
            key={myGroup.id}
            group={myGroup}
            properties={groupObject.properties}
          ></PropertiesSet>
        )
      })}
    </div>
  )
}

export default React.memo(PlayerTabProperties2)
